import { useClassName } from '@/styles/CoverBox';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type CoverBoxImagesProps = ComponentProps<'div'>;

export const CoverBoxImagesComponent: Component<CoverBoxImagesProps> = ({ children, ...props }) => {
  const className = useClassName('images', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
